import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/auth";
import { useUser } from "../contexts/UserContext";
import BottomNavBar from "../components/BottomNavBar";

const Logoff: React.FC = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const { clearUserData } = useUser();

  useEffect(() => {
    if (user) {
      signOut();
      clearUserData();
      navigate("/");
    } else {
      navigate("/");
    }
  }, [user, signOut, clearUserData, navigate]);

  return (
    <div className="content-container">
      <div className="flex items-center justify-center min-h-[calc(100vh-144px)]">
        <div className="w-16 h-16 border-4 border-black border-t-transparent rounded-full animate-spin"></div>
      </div>
      <BottomNavBar />
    </div>
  );
};

export default Logoff;
